import { request } from "$/lib/api"
import { CargoBikeLimit, Route, populateRoute } from "@repo/common"
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"

async function fetchCargoBikeLimit(storeId: string): Promise<CargoBikeLimit> {
  return await request<CargoBikeLimit>({
    url: populateRoute(Route.BOOKING_RULES__GET_CARGO_BIKE_LIMIT, storeId),
    method: "GET",
  })
}

async function setCargoBikeLimit(storeId: string, data: CargoBikeLimit) {
  return await request<void>({
    url: populateRoute(Route.BOOKING_RULES__SET_CARGO_BIKE_LIMIT, storeId),
    method: "PUT",
    data,
  })
}

export function useCargoBikeLimitMutation(storeId: string) {
  const queryClient = useQueryClient()

  const setMutation = useMutation({
    mutationFn: (data: CargoBikeLimit) => setCargoBikeLimit(storeId, data),
    onSettled: async () => {
      await queryClient.invalidateQueries(cargoBikeLimitQueries.detail(storeId))
    },
  })

  return { setMutation }
}

const cargoBikeLimitQueries = {
  detail: (storeId: string) =>
    queryOptions({
      queryKey: ["cargo-bike-limit", storeId],
      queryFn: () => fetchCargoBikeLimit(storeId),
    }),
}

export default cargoBikeLimitQueries
